import React from "react";
import {
  Button,
  Card,
  CardActionArea,
  CardMedia,
  Divider,
  Grid,
  Typography,
} from "@mui/material";

function AdditionalInformation({ data }) {
  return (
    <>
    <div className="pb-2 pt-2">
      <h5>Additional Information</h5>
      <div>
        <Typography color="primary" variant="h6">
          Current Salary
        </Typography>
        <Typography variant="subtitle1" style={{ color: "#595959" }}>
          Rp {data?.curr_salary}
        </Typography>
        <Typography color="primary" variant="h6">
          Current Benefits
        </Typography>
        <Typography variant="subtitle1" style={{ color: "#595959" }}>
          {data?.curr_benefits.map((e) => e).join(", ")}
        </Typography>
        <Typography color="primary" variant="h6">
          Expected Salary
        </Typography>
        <Typography variant="subtitle1" style={{ color: "#595959" }}>
          Rp {data?.expected_salary}
        </Typography>
        <Typography color="primary" variant="h6">
          Expected Benefits
        </Typography>
        <Typography variant="subtitle1" style={{ color: "#595959" }}>
          {data.expected_benefits.map((e) => e).join(", ")}
        </Typography>
      </div>
    </div>
    <Divider />
    </>
  );
}

export default AdditionalInformation;
